<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>관리자관리</h2>
                <div class="info_box">
                    <div>
                        총 관리자
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.totalLength) }}명</span>
                    </div>
                </div>
            </div>

            <div class="sch_condition_wrap">
                <div class="left">
                    <div class="checkbox_wrap sch_list">
                        <span class="sch_list_tit">담당사업</span>
                        <label>
                            <input type="checkbox" value="all" v-model="state.selectedRole" @change="toggleAllRole" />
                            <em></em>
                            <span>전체</span>
                        </label>

                        <label v-for="item in state.allRoleList" :key="item.roIdx">
                            <input type="checkbox" :value="item.roIdx" v-model="state.selectedRole" @change="handleRoleChange" />
                            <em></em>
                            <span>{{ item.roName }}</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="sch_condition_wrap" style="margin-top: 5px">
                <div class="left">
                    <div class="select_tab_box _130">
                        <div
                            class="selected_tab"
                            :class="[state.isShowSearchType ? 'active' : '']"
                            @click="state.isShowSearchType = !state.isShowSearchType"
                        >
                            <span>{{ state.detailTxt }}</span>
                        </div>
                        <div class="tab_option">
                            <button
                                v-for="item in search_type_list"
                                @click="
                                    state.searchType = item.key;
                                    state.detailTxt = item.value;
                                    state.isShowSearchType = false;
                                "
                            >
                                {{ item.value }}
                            </button>
                        </div>
                    </div>
                    <div class="search_wrap" style="width: 600px">
                        <input
                            type="text"
                            v-model="state.searchText"
                            @keyup.enter="
                                state.page = 1;
                                getList();
                            "
                            placeholder="검색어를 입력하세요."
                        />
                        <button
                            type="button"
                            class="search_btn icon_wrap"
                            @click="
                                state.page = 1;
                                getList();
                            "
                        >
                            <img src="img/search_btn.png" alt="" />
                        </button>
                    </div>
                </div>
                <div class="right">
                    <button type="button" class="default_btn _blue" @click="adminModal(null)">관리자 추가</button>
                    <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                    <button type="button"><img src="img/excel_icon.png" @click="downloadFile" alt=" 엑셀 다운로드" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 80px" />
                        <col style="width: 100px" />
                        <col style="width: 150px" />
                        <col style="width: 150px" />
                        <col />
                        <col style="width: 100px" />
                        <col style="width: 150px" />
                        <col style="width: 60px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            </th>
                            <th>번호</th>
                            <th>권한</th>
                            <th>아이디</th>
                            <th>이름</th>
                            <th>담당사업</th>
                            <th>가입일</th>
                            <th>최종접속</th>
                            <th>상태</th>
                            <th>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input
                                            type="checkbox"
                                            :id="'chk_' + item.idx"
                                            v-model="state.checkedList"
                                            :value="item.idx"
                                            @click.stop
                                            :disabled="item.idx === 1"
                                        />
                                        <em></em>
                                    </label>
                                </td>
                                <td class="list_num">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td>{{ item.memberVO.gubun === 1 ? "최고관리자" : "일반관리자" }}</td>
                                <td>{{ item.memberVO.id }}</td>
                                <td>{{ item.memberVO.name }}</td>
                                <td>
                                    <div class="tag_wrap" v-if="item.memberVO.gubun !== 1">
                                        <span v-if="item.roles?.includes('의심 업소 제보')" class="tag_yellow">의심업소제보</span>
                                        <span v-if="item.roles?.includes('알선 광고 제보')" class="tag_yellow">알선광고제보</span>
                                        <span v-if="item.roles?.includes('반성매매 시민활동')" class="tag_blue">반성매매시민활동</span>
                                        <span v-if="item.roles?.includes('캠페인') || item.roles?.includes('이벤트')" class="tag_blue">
                                            캠페인·이벤트
                                        </span>
                                        <span v-if="item.roles?.includes('반성매매 활동제안')" class="tag_blue">반성매매활동제안</span>
                                        <span v-if="item.roles?.includes('감시소식')" class="tag_blue">감시소식</span>
                                    </div>
                                    <div class="tag_wrap" v-else>
                                        <span class="tag_yellow">의심업소제보</span>
                                        <span class="tag_yellow">알선광고제보</span>
                                        <span class="tag_blue">반성매매시민활동</span>
                                        <span class="tag_blue">캠페인·이벤트</span>
                                        <span class="tag_blue">반성매매활동제안</span>
                                        <span class="tag_blue">감시소식</span>
                                    </div>
                                </td>
                                <td class="cnt">{{ CommonUtils.dateFormatYY(new Date(item.memberVO.createDate), ".") }}</td>
                                <td class="small cnt">
                                    {{ item.memberVO.loginDate ? CommonUtils.dateFormat(new Date(item.memberVO.loginDate), ".", true) : "" }}
                                </td>
                                <td class="cnt">{{ getStateText(item.memberVO.state) }}</td>
                                <td class="cnt">
                                    <button type="button" class="table_btn _blue" @click="adminModal(item.memberVO.idx)">수정</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="10"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <AdminManageModal
        v-if="state.isMemberShowModal"
        :idx="state.idx"
        :userInfo="state.userInfo"
        :modalRoleList="state.modalRoleList"
        :allRoleList="state.allRoleList"
        @close="state.isMemberShowModal = false"
        @callback="
            state.isMemberShowModal = false;
            getList();
        "
    ></AdminManageModal>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        AdminManageModal,
        types,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        computed,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, AdminManageModal: AdminManageModal },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const state = reactive({
                list: [] as Array<any>,
                checkedList: [] as Array<string>,
                checkAll: false as boolean,

                roleList: [] as Array<string>,
                allRoleList: [] as Array<any>,

                isShowSearchType: false,
                detailType: null as number | null,
                detailTxt: "전체" as string,
                searchType: "" as string,
                searchText: "" as string,
                idxList: [] as Array<string>,

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                isMemberShowModal: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                selectedRole: ["all"],
                idx: 0 as number,
                data: {},
                userInfo: {},
                modalRoleList: [] as Array<string>,
            });

            onMounted(() => {
                getList();
                getRoleList();
            });

            onBeforeUnmount(() => {});

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                    // state.checkAll = state.checkedList.length === state.list.filter((r) => r.idx !== 1).length;
                },
            );

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const openModal = (tab: number, isResult: boolean) => {
                state.modalTab = tab;
                state.isShowModal = true;
                state.modalIsResult = isResult;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const toggleAllRole = () => {
                if (state.selectedRole.includes("all")) {
                    state.selectedRole = ["all"];
                } else {
                    state.selectedRole = [];
                }
                state.page = 1;
                getList();
            };

            const handleRoleChange = () => {
                if (state.selectedRole.includes("all") && state.selectedRole.length > 1) {
                    state.selectedRole = state.selectedRole.filter((v) => v !== "all");
                }

                const allKeys = (roleList.value ?? []).map((c) => c.key);
                if (allKeys.every((key) => state.selectedRole.includes(key))) {
                    state.selectedRole = ["all"];
                }

                if (state.selectedRole.length === 0) {
                    state.selectedRole = ["all"];
                }

                state.page = 1;
                getList();
            };

            const getStateText = (param: number) => {
                switch (param) {
                    case 1:
                        return "정상";
                    case 2:
                        return "탈퇴";
                    case 3:
                        return "차단";
                    default:
                        return "대기";
                }
            };

            const search_type_list = [
                { id: "all", key: "all", value: "전체" },
                { id: "1", key: "name", value: "이름" },
                { id: "2", key: "id", value: "아이디" },
            ];

            const roleList = computed(() =>
                state.allRoleList.map((item) => ({
                    key: item.roKey,
                    label: item.roName,
                })),
            );

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.filter((r) => r.idx !== 1).map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqAdminList = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    roleIdxList: String(state.idxList),
                };

                if (!state.selectedRole.includes("all")) {
                    param.roleIdxList = state.selectedRole.join(",");
                }

                const res = await apiService.admin.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.roleList = res.list.data.roles;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const getRoleList = async () => {
                const res = await apiService.admin.getRoleList();
                state.allRoleList = res.data;
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqUserForExcel = {
                        searchType: state.searchType,
                        searchText: state.searchText,
                        idxList: String(state.checkedList),
                    };

                    let res = await apiService.admin.exportExcel(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const param: types.ReqIdxList = {
                        idxList: state.checkedList.join(","),
                    };
                    const res = await apiService.member.remove(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const adminModal = async (idx: number | null) => {
                if (idx != null && idx > 0 && idx != undefined) {
                    const res = await apiService.admin.detail(idx);

                    if (res.returnCode === 0) {
                        state.idx = idx;
                        state.userInfo = res.data.memberVO;
                        const roles: string = res.data.roles;
                        if (roles) {
                            state.modalRoleList = roles.split(",");
                        } else {
                            state.modalRoleList = [];
                        }
                        state.isMemberShowModal = true;
                    }
                } else {
                    state.idx = 0;
                    state.userInfo = {};
                    state.modalRoleList = [];
                    state.isMemberShowModal = true;
                }
            };

            return {
                state,
                user,
                router,
                closeModal,
                openModal,
                callBackModal,

                types,
                global,
                popup,
                CommonUtils,
                getStateText,
                search_type_list,
                handlePageChange,
                toggleAll,
                downloadFile,
                getList,
                isDelete,
                toggleAllRole,
                handleRoleChange,
                adminModal,
                getRoleList,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
